import React, { useState, useRef, useCallback, useEffect } from 'react';
import { getViewSetting } from '@react/Pages/UsersPage/UsersSection/UsersSections.utils';
import { UserGroup } from '@react/Pages/UsersPage/UsersPage/UsersPage.types';

import './UsersSection.scss';

export type UserSectionProps = {
  sectionName: UserGroup;
};

export const UsersSection: React.FC<UserSectionProps> = ({ sectionName, children }) => {
  const [active, setActive] = useState(true);
  const [scrollHeight, setScrollHeight] = useState(0);

  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = useCallback(() => {
    setActive(!active);
  }, [active]);

  useEffect(() => {
    setScrollHeight(contentRef?.current?.scrollHeight || 0);
    if (!active) {
      setActive(true);
    }
    // TODO we cannot to add active to the deps, need to find a solution
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);

  const { iconClassName, contentMaxHeight } = getViewSetting(active, scrollHeight);

  return (
    <div className="users-section">
      <div className="users-section__heading" onClick={toggleAccordion}>
        <p>{sectionName}</p>
        <i className={`icon-arrow-right ${iconClassName}`} />
      </div>
      <div ref={contentRef} style={{ maxHeight: `${contentMaxHeight}` }} className="users-section__content">
        {children}
      </div>
    </div>
  );
};
